<div class="messages">
  <app-message
    *ngFor="let message of messages.messages; let i = index"
    [message]="message"
    [style]="style"
    (removeMessage)="messages.removeMessage(i)"
  ></app-message>
</div>
